import React, { Component } from 'react'

// Elements
import VideoPlayer from '../../../shared/components/VideoPlayer'
import { getOrderVehicleData } from '../../../actions/orders'
import { saveEmbeddedBooking, getBookingPortalWelcomeMessageFromToken } from '../../../actions/embeddedbooking'

// utils
import { translation } from '../../../utils/helpers'

// Icons
import { EmbeddedBookingIcons } from '../../../shared/elements/icons'
import Icon from '../../../shared/elements/icon'

// constants
import { API_BASE } from '../../../constants'

// styles
import './introview.scss'
import { connect } from 'react-redux'
import Button from '../../../shared/elements/button'
import Text from '../../../shared/elements/text'

const INSTRUCTION_VIDEO = {
  DK: API_BASE + '/Content/Videos/booking_photoguide_dk.mp4',
  EN: API_BASE + '/Content/Videos/booking_photoguide_en.mp4',
  SE: API_BASE + '/Content/Videos/booking_photoguide_se.mp4',
  NO: API_BASE + '/Content/Videos/booking_photoguide_no.mp4'
}

class IntroView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      WelcomeMessage: null,
      CarData: {
        RegNumber: this.props.EmbeddedBooking.CarData.RegNumber,
        BrandNameId: '',
        Model: '',
        ChassisNumber: '',
        Km: 0
      },
      shops: null,
      regNumberError: false,
      regNumberChecked: false
    }

    this.onNextClick = this.onNextClick.bind(this)
    this.onRegBlur = this.onRegBlur.bind(this)
    this.onRegNrChange = this.onRegNrChange.bind(this)
    this.onNextToStep = this.onNextToStep.bind(this)
    this.onNextValidateReg = this.onNextValidateReg.bind(this)
    this.getBookingPortalWelcomeMessage = this.getBookingPortalWelcomeMessage.bind(this)
  }

  componentDidMount (props) {
    this.getBookingPortalWelcomeMessage()
  }

  getBookingPortalWelcomeMessage () {
    this.props.getBookingPortalWelcomeMessageFromToken(this.props.embedToken).then(res => {
      this.setState({WelcomeMessage: res.data})
    }, () => {
      console.error('error')
    })
  }

  onNextClick (e) {
    if (this.props.onNavClick !== null) {
      this.props.onNavClick(e, 'next')
    }
  }

  onRegBlur () {
    return new Promise((resolve, reject) => {
      if (!this.state.CarData.RegNumber || this.state.CarData.RegNumber.length === 0) {
        resolve && resolve()
        return
      }
      this.props.getOrderVehicleData(this.state.CarData.RegNumber, 'RegNumber').then(res => {
        this.setState({
          CarData: {
            ...this.state.CarData,
            RegNumber: res.data.RegNr,
            BrandNameId: res.data.BrandNameId,
            Model: res.data.Model,
            ChassisNumber: res.data.ChassisNumber
          },
          regNumberChecked: true
        }, () => {
          let updateData = {
            CarData: {
              IsDirty: true,
              RegNumber: this.state.CarData.RegNumber,
              BrandNameId: this.state.CarData.BrandNameId,
              Model: this.state.CarData.Model,
              ChassisNumber: this.state.CarData.ChassisNumber,
              Km: null
            }
          }
          this.props.saveEmbeddedBooking(updateData).then(res => resolve && resolve())
        })
      })
      .catch(() => {
        resolve && resolve()
      })
    })
  }

  onRegNrChange (e) {
    let value = e.target.value

    this.setState({
      CarData: {
        ...this.state.CarData,
        RegNumber: value
      },
      regNumberChecked: false,
      regNumberError: false
    })
  }

  onNextValidateReg () {
    const detectRegNrError = () => {
      if (this.state.regNumberError || this.state.CarData.RegNumber === null || this.state.CarData.RegNumber.length === 0) {
        this.setState({
          regNumberError: true
        })
        return true
      }
      return false
    }
    if (!this.state.regNumberChecked) {
      this.onRegBlur().then(() => {
        if (detectRegNrError()) return
        this.onNextToStep('with_regnr')
      })
      return
    }
    detectRegNrError()
    this.onNextToStep('with_regnr')
  }

  onNextToStep (flowType) {
    this.setState({
      regNumberError: false
    })
    if (flowType) {
      this.props.setFlowType(flowType)
    }
    this.onNextClick()
  }

  render () {
    let { CarData } = this.state

    return (
      <div className='intro__view'>
        <article className='main'>
          {this.props.children}
          <h1>{translation(18429)}</h1>
          <Text className={this.state.regNumberError ? 'required' : ''} name='CarData.RegNumber' value={CarData.RegNumber || ''} onChange={this.onRegNrChange} onBlur={this.onRegBlur} placeholder={translation(18430)} />
          <a className='link' onClick={this.onNextToStep.bind(this, 'no_regnr')}>{translation(18319)}</a>
          <div className='ctaWrapper'>
            <Button style='primary' labelText={translation(1223)} onClick={this.onNextValidateReg}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Right_Arrow}
                injectSvg
              />
            </Button>
          </div>
        </article>
        <aside className='side'>
          <section>
            <h1>{translation(16705)}</h1>
            {this.state.WelcomeMessage && <p>{this.state.WelcomeMessage.BookingPortalWelcomeMessageText}</p>}
          </section>

          <section>
            <h2>{translation(18317)}</h2>
            <p>{translation(18318)}</p>
            <VideoPlayer
              position={'center'}
              poster={''}
              src={INSTRUCTION_VIDEO[this.props.countryCode]}
              hideVolume
              autoHide
              autoHideTime={1000}
              />
          </section>

          <section>
            <h2>{translation(18431)}</h2>
            <ul>
              <li>{translation(16577)}</li>
              <li>{translation(16710)}</li>
              <li>{translation(16711)}</li>
            </ul>
          </section>
        </aside>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common,
    CarData: state.embeddedbooking.CarData,
    EmbeddedBooking: state.embeddedbooking
  }
}

export default connect(mapStateToProps, {
  getOrderVehicleData,
  saveEmbeddedBooking,
  getBookingPortalWelcomeMessageFromToken
})(IntroView)



// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/IntroView/index.js